import PropTypes from "prop-types"
import React, { useState } from "react"
import {MultiSelect} from "react-multi-select-component"
import {Col, FormGroup, Label} from "reactstrap"
import Select from "react-select"
import {withTranslation} from "react-i18next";
import Tooltip from "./tooltip";
import {filtrarEmpresas, filtrarEmpresaSelect} from "../../helpers/utils";

const FormSelectCompany = props => {

  const { attribute, options, value, changeHandeler, className, required, disabled, placeholder, description, setValue, multiple, title, keyTranslate, labelColumns, fieldColumns } = props

  const [touched, setTouched] = useState(false)

  const changeHandelerInput = (valor, elementId, validacao) => {
        if(validacao !== null && validacao !== undefined) {
            if(validacao === false) {
                document.getElementById(elementId).style.display = 'block'
            } else {
                document.getElementById(elementId).style.display = 'none'
            }
        } else {
            if (valor !== "" && valor !== undefined && valor !== null) {
                document.getElementById(elementId).style.display = 'none'
            } else {
                document.getElementById(elementId).style.display = 'block'
            }
        }
    }

  const ArrowRenderer = ({ expanded }) =><span className="arrow"></span>;
  const ClearRenderer = () =><span className="clear"></span>;

  return (
      <React.Fragment>
          <FormGroup className="mb-4" row>
              <Label htmlFor={ (attribute || 'empresa') + "-select" } className={ "col-form-label " + (labelColumns ? 'col-lg-' + labelColumns : 'col-lg-2')}>
                  { keyTranslate ? props.t(keyTranslate + '.label') : description || ( 'Empresa' + (multiple ? '(s)' : '')) }
                  { keyTranslate && <Tooltip id={ attribute + "-title"} tooltip={ props.t(keyTranslate + '.title') }></Tooltip>}
              </Label>
            <Col lg={fieldColumns || labelColumns || '10'}>
                  { multiple && <MultiSelect
                      id={ (attribute || 'empresa') + "-multi-multi-select" }
                      name={ (attribute || 'empresa') + "-multi-multi-select" }
                      className={ (className || "")  + (touched && required && !value? "is-invalid" : "")}
                      options={options}
                      placeholder= { disabled ? '' : (keyTranslate ? props.t(keyTranslate + '.placeholder') : (placeholder ? placeholder : `Digite a(s) ${description}`))}
                      title={ keyTranslate ? props.t(keyTranslate + '.title') : title}
                      value={value}
                      onChange={ value => {
                          if(!touched) setTouched(true)
                          setValue(value)
                          if(required) {
                              if(changeHandeler !== undefined) {
                                  changeHandeler(e.target.value, `validate-required-${ (attribute || 'empresa') }-select`)
                              } else {
                                  changeHandelerInput(e.target.value, `validate-required-${ (attribute || 'empresa') }-select`)
                              }
                          }
                      } }
                      labelledBy="Selecione"
                      disableSearch={false}
                      filterOptions={filtrarEmpresas}
                      overrideStrings={{
                          "allItemsAreSelected": "Todos selecionados.",
                          "clearSearch": "Limpar",
                          "clearSelected": "Deselecionar todos",
                          "noOptions": "Não há opções",
                          "search": "Pesquisar",
                          "selectAll": "Selecionar todos",
                          "selectAllFiltered": "Selecionar todos",
                          "selectSomeItems": "Selecione",
                          "create": "Criar",}
                      }
                      ClearIcon={<ClearRenderer />}
                      ClearSelectedIcon={<ClearRenderer />}
                      ArrowRenderer={ ArrowRenderer }
                      disabled={ disabled }
                  /> }

                  { !multiple && <Select
                      id={ (attribute || 'empresa') + "-select" }
                      name={ (attribute || 'empresa') + "-select" }
                      className={ "basic-single " + (touched && required && !value? "is-invalid" : "")}
                      options={ options }
                      placeholder= { disabled ? '' : (keyTranslate ? props.t(keyTranslate + '.placeholder') : (placeholder ? placeholder : `Digite a(o) ${description}`))}
                      title={ keyTranslate ? props.t(keyTranslate + '.title') : title}
                      isClearable={ !required}
                      isSearchable={true}
                      filterOption={filtrarEmpresaSelect}
                      noOptionsMessage={() => "Nenhuma empresa encontrada"}
                      onChange={e => {
                          if(!touched) setTouched(true)
                          setValue(e?.value)
                          if(required) {
                              if(changeHandeler !== undefined) {
                                  changeHandeler(e?.value, `validate-required-${ (attribute || 'empresa') }-select`)
                              } else {
                                  changeHandelerInput(e?.value, `validate-required-${ (attribute || 'empresa') }-select`)
                              }
                          }
                      }}
                      value={ value ? options.find(e => e.value === value) : undefined}
                      required={ required }
                      isDisabled={ disabled }
                  /> }

                  { required &&
                      <div className={ value ? "" : "invalid-tooltip" }
                           name="validate-required" id={ `validate-required-${ (attribute || 'empresa') }-select` }>
                          { value ? "" : `${ description } é obrigatório(a)`}
                      </div>
                  }
              </Col>
          </FormGroup>
      </React.Fragment>
  )
}

FormSelectCompany.propTypes = {
    value: PropTypes.any,
    changeHandeler: PropTypes.func,
    options: PropTypes.any,
    attribute: PropTypes.any,
    className: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    description: PropTypes.string,
    title: PropTypes.string,
    keyTranslate: PropTypes.string,
    labelColumns: PropTypes.number,
    fieldColumns: PropTypes.number,
    setValue: PropTypes.func,
}

export default withTranslation()(FormSelectCompany)